var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteWidget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A86602BF-1E2D-4E6D-84CD-9F489CF71339") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide_IBM-font",
    transform: "translate(-1286.000000, -175.000000)",
    fill: "#506D85",
    fillRule: "nonzero",
    stroke: "#506D85",
    strokeWidth: 0.550000012
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "translate(1284.272078, 174.272078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.296875,12.296875 L13.703125,12.296875 L13.703125,4.703125 C13.703125,4.31478906 13.3883359,4 13,4 C12.6116641,4 12.296875,4.31478906 12.296875,4.703125 L12.296875,12.296875 L4.703125,12.296875 C4.31478906,12.296875 4,12.6116641 4,13 C4,13.3883359 4.31478906,13.703125 4.703125,13.703125 L12.296875,13.703125 L12.296875,21.296875 C12.296875,21.6852109 12.6116641,22 13,22 C13.3883359,22 13.703125,21.6852109 13.703125,21.296875 L13.703125,13.703125 L21.296875,13.703125 C21.6852109,13.703125 22,13.3883359 22,13 C22,12.6116641 21.6852109,12.296875 21.296875,12.296875 Z",
    id: "Path",
    transform: "translate(13.000000, 13.000000) rotate(45.000000) translate(-13.000000, -13.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWidget);
export default __webpack_public_path__ + "static/media/delete-widget.15da4016ef2d883f9881fe8db626dc45.svg";
export { ForwardRef as ReactComponent };